import {
  NotificationDto,
  TopicType
} from '@bannerflow/types.notification-service';
import {
  CommentAddedNotification,
  ImageExportNotification,
  ThreadArchivedNotification,
  ThreadReopenedNotification,
  VideoExportNotification,
  AdScanningFinishedNotification,
  ResourceAccessApprovedNotification,
  ResourceAccessRejectedNotification,
  ResourceAccessRequestedNotification,
  AiVideoGenerationNotification,
  PredictiveScoringCompletedNotification
} from '../domain';

export function isVideoExportNotification(
  notification: NotificationDto | undefined
): notification is VideoExportNotification {
  return !!notification && notification.topic === TopicType.VideoExport;
}

export function isImageExportNotification(
  notification: NotificationDto | undefined
): notification is ImageExportNotification {
  return !!notification && notification.topic === TopicType.ImageExport;
}

export function isCommentAddedNotification(
  notification: NotificationDto | undefined
): notification is CommentAddedNotification {
  return !!notification && notification.topic === TopicType.CommentAdded;
}

export function isThreadArchivedNotification(
  notification: NotificationDto | undefined
): notification is ThreadArchivedNotification {
  return !!notification && notification.topic === TopicType.ThreadArchived;
}

export function isThreadReopenedNotification(
  notification: NotificationDto | undefined
): notification is ThreadReopenedNotification {
  return !!notification && notification.topic === TopicType.ThreadReopened;
}

export function isAdScanningFinishedNotification(
  notification: NotificationDto | undefined
): notification is AdScanningFinishedNotification {
  return !!notification && notification.topic === TopicType.AdScanningFinished;
}

export function isResourceAccessRequestedNotification(
  notification: NotificationDto | undefined
): notification is ResourceAccessRequestedNotification {
  return !!notification && notification.topic === TopicType.PermissionRequested;
}

export function isResourceAccessApprovedNotification(
  notification: NotificationDto | undefined
): notification is ResourceAccessApprovedNotification {
  return !!notification && notification.topic === TopicType.PermissionApproved;
}

export function isResourceAccessRejectedNotification(
  notification: NotificationDto | undefined
): notification is ResourceAccessRejectedNotification {
  return !!notification && notification.topic === TopicType.PermissionRejected;
}

export function isAiVideoGenerationNotification(
  notification: NotificationDto | undefined
): notification is AiVideoGenerationNotification {
  return (
    !!notification && notification.topic === TopicType.AiGenerationCompleted
  );
}

export function isPredictiveScoringCompletedNotification(
  notification: NotificationDto | undefined
): notification is PredictiveScoringCompletedNotification {
  return (
    !!notification &&
    notification.topic === TopicType.PredictiveScoringCompleted
  );
}

export function isSystemNotification(
  notification: NotificationDto | undefined
): boolean {
  return (
    isVideoExportNotification(notification) ||
    isImageExportNotification(notification) ||
    isAdScanningFinishedNotification(notification) ||
    isAiVideoGenerationNotification(notification) ||
    isPredictiveScoringCompletedNotification(notification)
  );
}
